import { ComponentProps, FC, ReactNode } from 'react';
import { Box, Button, Grid, Typography } from '@robocorp/components';
import { styled } from '@robocorp/theme';
import { IconMaximize2 } from '@robocorp/icons';

const BaseGridTable = styled(Grid).attrs({ gap: 0 })`
  overflow: hidden;
  border-radius: 6px;
  border-top: 2px solid ${({ theme }) => theme.color('border.primary')};
  border-left: 2px solid ${({ theme }) => theme.color('border.primary')};
`;

const Cell = styled(Box)`
  border-bottom: 2px solid ${({ theme }) => theme.color('border.primary')};
  border-right: 2px solid ${({ theme }) => theme.color('border.primary')};
`;

const ButtonBox = styled(Box)`
  position: relative;
  top: -10px;
  right: -10px;
`;

type GridCellProps = { children: ReactNode; heading?: string; onExpand?: () => void } & Omit<
  ComponentProps<typeof Cell>,
  'flexDirection'
>;

const GridCell: FC<GridCellProps> = ({ heading, children, onExpand, ...boxProps }) => {
  return (
    <Cell flexDirection="column" p={18} backgrounds={['background.primary']} {...boxProps}>
      <Box display="flex" width="100%" alignItems="center">
        {!!heading && (
          <Typography mb={4} fontSize="$16" colors={['content.subtle.light']}>
            {heading}
          </Typography>
        )}
        {!!onExpand && (
          <ButtonBox ml="auto">
            <Button
              size="small"
              variant="ghost"
              icon={IconMaximize2}
              onClick={onExpand}
              aria-label="expand"
            />
          </ButtonBox>
        )}
      </Box>
      {children || '-'}
    </Cell>
  );
};

export const GridTable = BaseGridTable as unknown as FC<ComponentProps<typeof BaseGridTable>> & {
  Cell: typeof GridCell;
};

GridTable.Cell = GridCell;
